import React, { useEffect, useState } from "react";
import Logo from "../../../assets/img/logo.png";
import EyeBlock from "../../../assets/img/eye_block.svg";
import EyeOpen from "../../../assets/img/eye_open.svg";
import { SuccessWithButton } from "../../../components/Alert";
import api from "../../../config/api";

function ChangePassword(props) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const [regexPassword, setRegexPassword] = useState(false);
  const [error, setError] = useState("");
  const [user, setUser] = useState({});

  const passwordNotSame = "*Senhas não conferem, digite novamente.";
  const regexPasswordError =
    "As senhas devem ter no mínimo 8 caracteres contendo uma letra, um número e um caracter especial";

  const handleChange = (event) => {
    setUser((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const show = (e) => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  const showConfirm = (e) => {
    e.preventDefault();
    setShowConfirmPassword(!showConfirmPassword);
  };

  function validarSenha(event) {
    const regex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={[}\]|\\:;"'<,>.?/-]).{8,}$/;
    let pw = regex.test(event.target.value);
    setRegexPassword(pw);
    if (pw) {
      handleChange(event);
    }
  }

  const save = async (e) => {
    e.preventDefault();

    if (!regexPassword) {
      setErrorPassword(true);
      setError(regexPasswordError);
      return;
    }

    if (user.password === user.confirmPassword && user.password !== "" && user.confirmPassword !== "") {
      setErrorPassword(false);

      const { token } = props.match.params;
      await api.put("/new-password-dashboard", { password: user.password, token }).then((res) => {
        document.getElementById("btnCallSuccess").click();
      });
    } else {
      setErrorPassword(true);
      setError(passwordNotSame);
    }
  };

  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <>
      <div className="container-fluid mb-5 mb-lg-0  h-100">
        <div className="row h-100">
          <div className="bg-img-login h-100 col-lg-7 d-flex justify-content-start align-items-end ">
            <div className="row m-0">
              <h1 className="title mb-3 text-white fz-34 ff-univanova-300">
                Bem-vindo ao <br />
                <span className="ff-univanova-bold">RESERVEI</span>
              </h1>
              {/* <h2 className="subtitle mb-4 text-white fz-16 ff-univanova-300">
                Lorem ipsum dolor sit amet, consetetur
              </h2> */}
            </div>
          </div>
          <div className="col-lg-5 mt-5 my-lg-auto">
            <form className="px-3 mb-5 mb-lg-0" onSubmit={save}>
              <div className="d-flex justify-content-center align-items-center mb-5">
                <img alt="" src={Logo} />
              </div>
              <div className="mb-4">
                <h2 className="d-flex justify-content-center ff-univanova-600 fz-24 text-cl-cyan">Alterar senha</h2>
              </div>
              <div className="">
                <h2 className="ff-univanova-regular fz-16 text-cl-cyan">Nova senha</h2>
                <div className="eye-component d-flex">
                  <input
                    name="password"
                    onChange={(event) => {
                      validarSenha(event);
                      // handleChange(event);
                    }}
                    type={showPassword ? "text" : "password"}
                    placeholder="Digite sua senha"
                    className="password input-line form-control ff-univanova-regular fz-14 text-cl-auroMetal px-0 w-90"
                    required
                  />
                  <button onClick={(event) => show(event)} className="btn-eye">
                    <img
                      alt=""
                      width={"24px"}
                      height={"24px"}
                      className=" w-auto"
                      src={showPassword ? EyeOpen : EyeBlock}
                    />
                  </button>
                </div>
              </div>
              <div className="">
                <h2 className="ff-univanova-regular fz-16 text-cl-cyan">Confirmar nova senha</h2>
                <div className="eye-component d-flex">
                  <input
                    name="confirmPassword"
                    onChange={(event) => handleChange(event)}
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Digite sua senha novamente"
                    className="password input-line form-control ff-univanova-regular fz-14 text-cl-auroMetal px-0 w-90"
                    required
                  />
                  <button onClick={(event) => showConfirm(event)} className="btn-eye">
                    <img
                      alt=""
                      width={"24px"}
                      height={"24px"}
                      className=" w-auto"
                      src={showConfirmPassword ? EyeOpen : EyeBlock}
                    />
                  </button>
                </div>
              </div>
              <div className="mb-3">{errorPassword ? <span className="text-cl-red fz-14">{error}</span> : <></>}</div>
              <div style={{ marginBottom: "24px" }}>
                <button
                  type="submit"
                  className="w-100 btn bg-gradient-cyan-blue text-white font-poppins py-2 fz-18 d-flex justify-content-center ff-univanova-medium"
                >
                  Alterar
                </button>
              </div>
              <div className="d-flex align-items-center justify-content-end check-box">
                <div className="d-flex align-items-center">
                  <span className="text-cl-auroMetal fz-14 ff-univanova">Já tem conta?</span>
                  <div className={`d-flex justify-content-end ms-3`}>
                    <button
                      onClick={() => (document.location.href = "/")}
                      className="btn btn-white button-white-primary fz-16 px-4 ff-univanova-medium"
                      type="button"
                    >
                      Fazer login
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <button id="btnCallSuccess" className="d-none" data-bs-toggle="modal" data-bs-target="#NewPassword">
        Chamar modal success
      </button>
      <SuccessWithButton
        id="NewPassword"
        title={"Alteração realizada com sucesso!"}
        description="foi feita a alteração da sua senha"
        buttonOnClick={() => (document.location.href = "/")}
        buttonText="Login"
      />
    </>
  );
}

export default ChangePassword;
